// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"be2875ef","318":"ec766e43","483":"136a5742","810":"50f9d469","928":"b5f16278","932":"3d246ba9"}[chunkId] + ".chunk.js";
};